import { render } from "./mat-datepicker.vue?vue&type=template&id=2dd655f4"
import script from "./mat-datepicker.vue?vue&type=script&lang=js"
export * from "./mat-datepicker.vue?vue&type=script&lang=js"

import "./mat-datepicker.vue?vue&type=style&index=0&id=2dd655f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__